import { Tag } from '../../shared/models/tag.model';


/**
 * Tag that associates additional information with an airport.
 */
export class AirportTag extends Tag {
  /**
   * Unique identifier for this record in the database. This property identifies the record that links this tag to a
   * specific airport (as oppsoed to Tag.tagId, which identifies the tag definition record).
   */
  aptTagId: number;

  /**
   * Airport record ID for which this record applies
   */
  airportId: number;

  /**
   * Source ID that identifies the source of this data (e.g., airport manager)
   */
  sourceId: number;

  /**
   * Parses tag
   * @param data {any} Tag as returned by API
   * @return {Tag} Parsed tag
   */
  static parse(data: any): Tag {
    const tag = Tag.parse(data);
    return Object.assign(tag, {
      aptTagId: data.aptTagId,
      airportId: data.airportId,
      sourceId: data.sourceId
    });
  }
}
